export const UPLOAD_PROPS = {
  name: 'file',
  multiple: false,
};
